import * as React from 'react';
import _ from 'lodash';
import { ImOkStatusType } from '../../utils/enums';
import type { Icon } from './ImOkUserItem';
import ImOkUserItem from './ImOkUserItem';
import {
  CountText,
  EmptyList,
  ResponseListContainer,
  ResponseRow,
  SwitchButton,
  SwitchButtonText,
  UserWrapper,
} from './ImOk.styles';
import { translate } from '../../utils/translate';
import type { ImOkDocumentSimple, ImOkUser } from '../../containers/ImOkList/imOkSlice/types';
import { palette } from '../../theme/colors';
import type { IamOkLocationDataType } from '../../containers/ImOkDocument/ImOkDocument';

type ImOkResponseListProps = {
  activeButton: ImOkStatusType;
  setActiveButton: (id: ImOkStatusType) => void;
  imOkDocument: ImOkDocumentSimple;
  messageHeight?: number;
  handleMapClick: (data: IamOkLocationDataType) => void;
};

export const ImOkResponseList = (props: ImOkResponseListProps) => {
  const { activeButton, setActiveButton, imOkDocument, messageHeight, handleMapClick } = props;
  const { recipientsOk, users, groups, id: iAmOkId } = imOkDocument;

  const buttonRowItems: Icon[] = [
    {
      id: ImOkStatusType.NotOk,
      text: 'imOk_notOk',
      count: _.filter(users, user => user.imok === false).length,
      color: palette.tartOrange,
      align: 'flex-start',
    },
    {
      id: ImOkStatusType.NoStatus,
      text: 'imOk_notStatus',
      count: _.filter(users, user => user.imok === null).length,
      color: 'transparent',
      align: 'center',
    },
    {
      id: ImOkStatusType.Ok,
      text: 'imOk_Ok',
      count: recipientsOk,
      color: palette.applGreen,
      align: 'flex-end',
    },
  ];

  const selectedUserGroup = () => {
    if (activeButton === ImOkStatusType.NotOk) {
      return _.filter(users, user => user.imok === false);
    }
    if (activeButton === ImOkStatusType.Ok) {
      return _.filter(users, user => user.imok === true);
    }
    return _.filter(users, user => user.imok === null);
  };
  const selectedGroup = _.find(buttonRowItems, button => button.id === activeButton);

  const onMapClick = (userItem: ImOkUser) => () =>
    handleMapClick({
      locationName: userItem.locationName ?? '',
      latitude: userItem.locationLatitude ?? 0,
      longitude: userItem.locationLongitude ?? 0,
      accuracy: userItem.locationAccuracy ?? undefined,
      userName: userItem.username ?? '',
      lastupdated: userItem.lastupdated,
    });

  return (
    <ResponseListContainer $removedHeight={messageHeight} role="responsesViewContainer">
      <ResponseRow role="responsesRow">
        {_.map(buttonRowItems, (button, index) => {
          return (
            <SwitchButton
              align={button.align}
              active={button.id === activeButton}
              onClick={() => setActiveButton(button.id)}
              key={index}
              role={`response-${button.text}`}
            >
              <SwitchButtonText
                role="responseTitle"
                active={button.id === activeButton}
                isNoStatus={button.id == ImOkStatusType.NoStatus}
                color={button.color}
              >
                {translate(button.text)}
              </SwitchButtonText>
              <CountText role="responsesCountText" active={button.id === activeButton}>
                {`(${button.count || 0})`}
              </CountText>
            </SwitchButton>
          );
        })}
      </ResponseRow>
      {selectedUserGroup().length && selectedGroup ? (
        <UserWrapper role="usersContainer">
          {_.map(selectedUserGroup(), (userItem, index) => {
            return (
              <ImOkUserItem
                key={index}
                user={userItem}
                groupId={groups[0].id!}
                iAmOkId={iAmOkId}
                selectedGroup={selectedGroup}
                handleMapClick={onMapClick(userItem)}
              />
            );
          })}
        </UserWrapper>
      ) : (
        <EmptyList role="emptyList">
          <p>{translate('imOk_noMessages')}</p>
        </EmptyList>
      )}
    </ResponseListContainer>
  );
};
